import React from "react";
import { GraphsListViewWrap } from "./GraphsListViewWrap";

const GraphsListReactView = () => {
  return <GraphsListViewWrap />;
};

window.GraphsListReactView = GraphsListReactView;
